import { Component, OnInit } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuditService } from '../../services/audit.service';
import { takeUntil } from 'rxjs/operators';
import { AuditCardAcceptorConfigViewModel } from '../../models/audit-trail-card-acceptor-config-view-model';
import { LoggedInUser } from '../../models/user';
import { ParticipantViewModel } from '../../models/participant-view-model';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { ConfirmationDialogComponent } from '../../partials/confirmation-dialog/confirmation-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TerminalConfigViewModel } from '../../models/terminal-config-view-model';
import { AuditTerminalConfigViewModel } from '../../models/audit-trail-terminal-config-view-model';
import { PermissionEnum } from '../../services/guards/permissions';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';


@Component({
  selector: 'app-terminal-config-audit',
  templateUrl: './terminal-config-audit.component.html',
  styleUrls: ['./terminal-config-audit.component.scss']
})
export class TerminalConfigAuditComponent implements OnInit {

  public dtTrigger: Subject<boolean> = new Subject();
  private _destroyed$ = new Subject<any>();
  public terminalConfigViewModel: AuditTerminalConfigViewModel[] = [];
  public currentUser: Observable<LoggedInUser>;
  public participants: ParticipantViewModel[];
  public selectedParticipant: number;
  public selectedParticipantName: string;

  public dtOptions: DataTables.Settings = {};
  public id: string;
  public currentDate: string;
  public canView: boolean;

  constructor(private _route: ActivatedRoute,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _auditService: AuditService,
    private _userDataStore: UserDataStoreService,
    private _modalService: NgbModal,
    private _toastService: ToastrService,
    private _router: Router) {

    this.currentUser = _userDataStore.currentUser
    this.participants = this._userDataStore.userParticipants;
    this.selectedParticipant = this._userDataStore.selectedParticipant.id;


    _route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {
      this.id = params.id;
    });

    var today = new Date();
    // var yyyy = today.getFullYear();
    // var mm = today.getMonth();
    // var day = today.getDay();
    this.currentDate = moment(today).format('lll'); //'' + yyyy + '-' + mm + '-' + day;

    this.canView = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTerminalAudit], []);
    if (!this.canView) {
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.init();
  }

  public async initTable(selectedIndex: number): Promise<void> {

    if (selectedIndex == 2) {
      this.dtTrigger = new Subject();
      this.dtTrigger.next();
    }
  }

  private async init(): Promise<void> {

    this._ngxUiLoaderService.start();

    this.terminalConfigViewModel = await this._auditService.GetTerminalConfigsByIdentifier("" + this.id);
    this.dtTrigger.next();

    this._ngxUiLoaderService.stop();
  }

  public async openReadMoreDialog(audit: AuditTerminalConfigViewModel): Promise<void> {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = false;
    dialogRef.componentInstance.acceptButtonText = "Close";
    dialogRef.componentInstance.title = "Terminal Config audit trail";

    var str = [];
    // str.push("Id: " + audit.id);
    // str.push("Changed By: " + audit.changedBy);
    // str.push("changed On: " + audit.changedOn);
    // str.push("source: " + audit.source);
    str.push("User Id: " + audit.userId);
    // str.push("name: " + audit.name);
    str.push("Participant Id: " + audit.participantId);
    str.push("Days To Keep Stats : " + audit.daysToKeepStats);
    str.push("Function Vector: " + audit.functionVector);
    str.push("Gmt Time Zone Offset: " + audit.gmtTimeZoneOffset);
    str.push("Hardware Config: " + audit.hardwareConfig);
    str.push("Hot File Id: " + audit.hotFileId);
    //str.push("Last Message Time: " + audit.lastMessageTime);
    //str.push("Last Message Type: " + audit.lastMessageType);
    //str.push("Last TranMsg Time: " + audit.lastTranMsgTime);
    str.push("Mac Master Key : " + audit.macMasterKey);
    str.push("Media Team: " + audit.mediaTeam);
    str.push("Miscellaneous : " + audit.miscellaneous);
    str.push("Mode: " + audit.mode);
    str.push("Pin Master Key : " + audit.pinMasterKey);
    str.push("Postal Service Code: " + audit.postalServiceCode);
    str.push("Sec Mod Nr: " + audit.secModNr);
    str.push("Security Team : " + audit.securityTeam);
    str.push("Sponsor Bank: " + audit.sponsorBank);
    str.push("State Code : " + audit.stateCode);
    str.push("Status : " + audit.status);
    str.push("Supplies Team : " + audit.suppliesTeam);
    str.push("Support Team : " + audit.supportTeam);
    str.push("Time Zone : " + audit.timeZone);
    str.push("Value Bars : " + audit.valueBars);
    str.push("Worst Event Severity : " + audit.worstEventSeverity);
    str.push("POS Data Code : " + audit.posDataCode);
    str.push("Heart Beat : " + audit.heartBeat);
    str.push("Heart Beat Delay : " + audit.heartbeatDelay);
    str.push("Time Zone Code : " + audit.timeZoneCode);
    str.push("Enable Ej Upload : " + audit.enableEjUpload);
    str.push("Sample Rate : " + audit.sampleRate);
    str.push("BIN Profile : " + audit.binProfile);
    str.push("DUKPT Management : " + audit.dukptManagement);
    str.push("Disable Media Management : " + audit.disableMediaManagement);
    str.push("Type : " + audit.type);
    str.push("Product Profile : " + audit.productProfile);
    str.push("Capability Profile : " + audit.commsProfile);
    str.push("Comms Profile : " + audit.commsProfile);
    str.push("Driver Id : " + audit.driverId);
    // str.push("County Code : " + audit.countyCode);
    str.push("Term Rkt Scheme : " + audit.termRktScheme);
    str.push("UsePos Data Code Config : " + audit.usePosDataCodeConfig);
    str.push("Config Id : " + audit.configId);


    dialogRef.componentInstance.listMessage = str;

  }

  public print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('content').innerHTML;
    popupWin = window.open('', '_blank', 'top=50,left=1,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
           <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  public DownloadCardAcceptorAuditDetailsCsv(): void {
    const data = this.terminalConfigViewModel;
    const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    const csv = data.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');

    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = ('TerminalConfigAuditTrail_' + this.currentDate + ".csv");
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }


  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
    //this.subscription.unsubscribe();
  }
}
